import { combineReducers } from 'redux';
import taxes from './taxes/reducer';
import discounts from './discounts/reducer';
import loyalty from './loyalty/reducer';
import waitingList from './waitingList/reducer';
import promoCodes from './promoCodes/reducer';
import subscription from './subscription/reducer';
import * as types from './constants';

const bankAccount = (state = null, action) => {
  switch (action.type) {
    case types.REQUEST_BANK_ACCOUNT:
      return null;

    case types.IMPORT_BANK_ACCOUNT:
      return action.bankAccount;

    case types.DELETE_BANK_ACCOUNT:
      return null;

    default:
      return state;
  }
};

const debitCard = (state = null, action) => {
  switch (action.type) {
    case types.ADD_DEBIT_CARD:
    case types.REQUEST_DEBIT_CARD:
    case types.UPDATE_DEBIT_CARD:
      return action.payload;
    case types.DELETE_DEBIT_CARD:
      return null;
    default:
      return state;
  }
};

const merchantInfo = (state = null, action) => {
  switch (action.type) {
    case types.SET_MERCHANT_INFO:
      return action.payload;
    default:
      return state;
  }
};

const balance = (state = null, { type, payload }) => {
  switch (type) {
    case types.FETCH_BALANCE:
      return payload;
    default:
      return state;
  }
};

const initiateInstantPayout = (state = { isFetching: false }, { type }) => {
  switch (type) {
    case types.INITIATE_INSTANT_PAYOUT:
      return { ...state, isFetching: true };
    case types.FETCH_BALANCE:
      return { ...state, isFetching: false };
    default:
      return state;
  }
};

const paymentCard = (state = false, { type, payload }) => {
  switch (type) {
    case types.FETCH_SUBSCRIPTION_PAYMENT_CARD:
    case types.UPDATE_SUBSCRIPTION_PAYMENT_CARD:
      return payload;
    default:
      return state;
  }
};

export default combineReducers({
  bankAccount,
  debitCard,
  taxes,
  merchantInfo,
  discounts,
  loyalty,
  waitingList,
  balance,
  initiateInstantPayout,
  paymentCard,
  promoCodes,
  subscription,
});
